import { render, staticRenderFns } from "./modifyInfo.vue?vue&type=template&id=130fb642&scoped=true"
import script from "./modifyInfo.vue?vue&type=script&lang=js"
export * from "./modifyInfo.vue?vue&type=script&lang=js"
import style0 from "./modifyInfo.vue?vue&type=style&index=0&id=130fb642&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fb642",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('130fb642')) {
      api.createRecord('130fb642', component.options)
    } else {
      api.reload('130fb642', component.options)
    }
    module.hot.accept("./modifyInfo.vue?vue&type=template&id=130fb642&scoped=true", function () {
      api.rerender('130fb642', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/customerModifyManage/modifyInfo.vue"
export default component.exports